import React from 'react'
import AddEasyAccessForm from '../EasyAccess/components/AddEasyAccessForm'
import { Button, Popover, OverlayTrigger, Glyphicon } from 'react-bootstrap'
import "../../components/Cluster/cluster.css"

const AddClusterEasyAccess = ({ lock, i, door, allocateDoor }) => {
    let overlay

    const popoverTop = (
        <Popover id="popover-positioned-bottom">
            <AddEasyAccessForm allocateDoor={allocateDoor} lock={lock} door={door} key={i} />
        </Popover>
    )

    return (
        <OverlayTrigger
            rootClose
            placement="bottom"
            trigger="click"
            ref={node => (overlay = node)}
            overlay={popoverTop}
            >


            <Button style={{marginLeft:"13%", marginBottom:"-70px"}} className="cluster-box-button" >
                <Glyphicon glyph="glyphicon glyphicon-plus" /> Tilldela utrymme
            </Button>

        </OverlayTrigger>
    )

}

export default AddClusterEasyAccess